import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

import { Meta } from "@/@types/paginated";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface GridPaginationProps {
  meta: Meta;
  totalRows: number;
  perPage: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
}

export default function GridPagination({
  meta,
  totalRows,
  perPage,
  onPageChange,
  onPerPageChange,
}: GridPaginationProps) {
  return (
    <div className="flex flex-col space-y-4 px-2 mt-4 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
      <div className="flex-1 text-sm text-muted-foreground text-center sm:text-left">
        {totalRows} linha(s) encontrada(s).
      </div>
      <div className="flex flex-col space-y-4 sm:flex-row sm:items-center sm:space-y-0 sm:space-x-6 lg:space-x-8">
        <div className="flex items-center justify-center space-x-2 sm:justify-start">
          <p className="text-sm font-medium">Linhas por página</p>
          <Select
            value={`${perPage}`}
            onValueChange={(value) => onPerPageChange(Number(value))}
          >
            <SelectTrigger className="h-8 w-[70px]">
              <SelectValue placeholder={perPage} />
            </SelectTrigger>
            <SelectContent side="top">
              {[10, 25, 50, 100].map((pageSize) => (
                <SelectItem key={pageSize} value={`${pageSize}`}>
                  {pageSize}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-center justify-center text-sm font-medium sm:w-[100px]">
          Página {meta.currentPage} de {meta.lastPage}
        </div>
        <div className="flex items-center justify-center space-x-2 sm:justify-start">
          <Button
            variant="outline"
            className="h-8 w-8 p-0 sm:flex lg:flex"
            onClick={() => onPageChange(1)}
            disabled={meta.prev === null}
          >
            <span className="sr-only">Ir para a primeira página</span>
            <ChevronsLeft />
          </Button>

          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            onClick={() => onPageChange(meta.currentPage - 1)}
            disabled={meta.prev === null}
          >
            <span className="sr-only">Ir para a página anterior</span>
            <ChevronLeft />
          </Button>

          <Button
            variant="outline"
            className="h-8 w-8 p-0"
            onClick={() => onPageChange(meta.currentPage + 1)}
            disabled={meta.next === null}
          >
            <span className="sr-only">Ir para a próxima página</span>
            <ChevronRight />
          </Button>

          <Button
            variant="outline"
            className="h-8 w-8 p-0 sm:flex lg:flex"
            onClick={() => onPageChange(meta.lastPage)}
            disabled={meta.next === null}
          >
            <span className="sr-only">Ir para a última página</span>
            <ChevronsRight />
          </Button>
        </div>
      </div>
    </div>
  );
}
